import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function OzguvenTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['ozguven-testi']} />;
}
